module.exports = __webpack_public_path__ + "Roboto-Light-webfont.816d43bc217485bc52e3.woff";


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/assets/fonts/roboto/Roboto-Light-webfont.woff
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Light-webfont.woff
// module chunks = 2